export default "__VITE_ASSET__Bd$7rsVV__ 1000w";